module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"birthdate":"Birthdate","client":"@:labels.client","title":"@:labels.info"},"fr":{"birthdate":"Anniversaire","client":"@:labels.client","title":"@:labels.info"}}')
  delete Component.options._Ctor
}
